import { clsx } from "@trydig/ui";
import type { PropsWithChildren } from "react";
import styles from "./ImageTag.module.css";

/**
 * To be used inside a parent with 'position : relative'
 */

export const ImageTag = ({
	children,
	position = "top-left",
}: PropsWithChildren<{ position?: "down-left" | "top-left" }>) => {
	if (!children) return null;
	return (
		<div className={clsx(styles.root, styles[position])}>
			<p className={styles.inner}>{children}</p>
		</div>
	);
};
